


    <div *ngIf="!(isCheckIn$|async) then checkIn else checkOut">
    </div>

<ng-template #checkIn>
 <div *ngIf="locationAddress$|async  as location else loader ">
<div class="custom-title" mat-dialog-title > Are you ready to check-in?</div>
<div class="custom-content" mat-dialog-content>You have arrived
  <span  class="custom-content"> at {{location}}</span>
  to begin your work.<br>
  Please confirm.</div>
   <div mat-dialog-actions class="custom-actions">
     <button class="home365-button primary  space-right" [mat-dialog-close] = {status:true,address:location}>Confirm</button>
     <button class="home365-button primary inverted space-right" (click)="CancelOption()"  >Cancel</button>
   </div>
 </div>



  <ng-template #loader>
    <div *ngIf="!addressExists">
      <div class="custom-title" mat-dialog-title > Are you ready to check-in?</div>
      <div class="custom-content" mat-dialog-content>You have arrived
        to begin your work.<br>
        Please confirm.</div>
      <div mat-dialog-actions class="custom-actions">
        <button class="home365-button primary  space-right" [mat-dialog-close] = {status:true,address:null}>Confirm</button>
        <button class="home365-button primary inverted space-right" (click)="CancelOption()"  >Cancel</button>
      </div>
    </div>
    <div *ngIf="addressExists" >
      <lib-home365-loader></lib-home365-loader>
    </div>

  </ng-template>

</ng-template>
<ng-template #checkOut>
  <div class="custom-title" mat-dialog-title > Are you ready to check-out?</div>

  <div class="custom-content" mat-dialog-content>Please confirm the check out
    <span  class="custom-content" *ngIf="locationAddress$|async as location"> from {{location}}</span>
  </div>



  <div mat-dialog-actions class="custom-actions">
    <button class="home365-button primary  space-right" [mat-dialog-close] = {status:false,address:location} [disabled]=!addressExists *ngIf="locationAddress$|async as location" >Confirm</button>
    <button class="home365-button primary  space-right" [mat-dialog-close] = {status:false,address:null} [disabled]=addressExists  *ngIf="!(locationAddress$|async) as location" >Confirm</button>
    <button class="home365-button primary inverted space-right" (click)="confirmCancelCheckOut()" >Cancel</button>
  </div>
</ng-template>

